/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_EditInputs */

const he_account_reviews_edit = /** @type {(inputs: Account_Reviews_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ערוך ביקורת`)
};

const en_account_reviews_edit = /** @type {(inputs: Account_Reviews_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit review`)
};

/**
* | output |
* | --- |
* | "Edit review" |
*
* @param {Account_Reviews_EditInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_reviews_edit = /** @type {((inputs?: Account_Reviews_EditInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_EditInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_edit(inputs)
	return en_account_reviews_edit(inputs)
});